<template>
  <div class="container">
    <div class="row">
      <div class="col-sm">
        <FixedUnitInput
          :input-label="t('before')"
          v-model.number="beforeValue"
          :unit="t('units')"
        />
        <FixedUnitInput
          :input-label="t('after')"
          v-model.number="afterValue"
          :unit="t('units')"
        />
      </div>
      <div class="col-sm">
        <FixedUnitOutput
          :output-label="t('change')"
          :number="changedValue"
          unit="%"
        />
      </div>
    </div>
  </div>
</template>

  
  <script>
  import { ref, computed, reactive } from 'vue';
  import FixedUnitInput from '../inputs/FixedUnitInput.vue';
  import FixedUnitOutput from '../inputs/FixedUnitOutput.vue';
  import { defaultRound } from '../../utils/math';
  import { useI18n } from 'vue-i18n';
  
  export default {
    components: {
      FixedUnitInput,
      FixedUnitOutput,
    },
    setup() {
      
      const beforeValue=ref(110);
      const afterValue=ref(20);
    
      const changedValue = computed(() => {
        return defaultRound((afterValue.value - beforeValue.value) / beforeValue.value*100);
      });

      const { t } = useI18n();

      // Create a reactive object with a function
      const translations = reactive({
        t: (key) => t(key)
      })
  
      
  
      return {
        beforeValue,
        afterValue,
        changedValue,
        t: translations.t,
      };
    }
  };
  </script>
  